import {
  ProductCategory,
  ShoppingPlatform,
} from "@/types/enums";

export const mockRootProps = {
  banners: [
    {
      id: "banner-1",
      image: "/images/products/bg_hero_banner.jpg",
      url: "https://example.com/banner1",
    },
    {
      id: "banner-2",
      image: "/images/products/bg_hero_banner.jpg",
      url: "https://example.com/banner2",
    },
    {
      id: "banner-3",
      image: "/images/products/bg_hero_banner.jpg",
      url: "https://example.com/banner3",
    },
  ],
  products: [
    {
      id: "1",
      name: "ปลาร้าเชฟไพรฑูรย์ สูตรนัวกลมกล่อม (น้ำปลาร้าปรุงสุก)",
      size: "ปริมาณสุทธิ 400 มล.",
      price: {
        amount: '-',
        currency: "",
      },
      image: "/images/products/fermented-fish-chef-praidturey-savory/image.jpg",
      category: ProductCategory.FISH_SAUCE,
      description: `ปลาร้าพรีเมียมจากขอนแก่น หอม กลมกล่อม เข้มข้นทุกหยด
                - ต้มสุกทุกขั้นตอน สะอาด ปลอดภัย ได้มาตรฐาน อย. ฮาลาล และ OTOP
                - ควบคุมรสชาติทุกขวด ด้วย QC และอุปกรณ์ชั่งตวงสูตรเฉพาะ
                - กลิ่นหอมไม่ติดมือ คนทำงานออฟฟิศก็ทานได้สบาย
                - อัดแน่นด้วยเนื้อปลาทุกหยด  มีไอโอดีนจากปลากระตัก วิตามินบี และโปรตีนสูง
                - ปรุงอาหารแล้วไม่เซ็งไม่บูดง่าย ด้วยกระบวนการเคี่ยวจนได้ที่
                - ใช้ได้สารพัดเมนู  ตำ ยำ หมักเนื้อ ไข่เจียว ลาบ ก้อย และอีกมากมาย
                - เป็นของดีเมืองขอนแก่น ของฝากจากเขื่อนอุบลรัตน์
                - ออกแบบรสชาติด้วยเชฟที่เชี่ยวชาญด้านเครื่องปรุงโดยตรง การันตีความคุ้มค่าทุกหยด แน่นอน`,
      shoppingPlatforms: [
        {
          id: "1",
          name: "น้ำปลาร้าเชฟไพรฑูรย์",
          platform: ShoppingPlatform.SHOPEE,
          logo: "/images/platforms/shopee.png",
          url: "https://shopee.co.th/chefpraitoon_official",
        },
        {
          id: "2",
          name: "Praitoon Food",
          platform: ShoppingPlatform.LAZADA,
          logo: "/images/platforms/lazada.png",
          url: "https://www.lazada.co.th/shop/praitoon-food",
        },
        {
          id: "3",
          name: "Praitoon Food",
          platform: ShoppingPlatform.TIKTOK,
          logo: "/images/platforms/tiktok.png",
          url: "https://vt.tiktok.com/ZSkpDWGYR",
        },
        {
          id: "4",
          name: "Praitoon Food",
          platform: ShoppingPlatform.LINE,
          logo: "/images/platforms/line-shopping.png",
          url: "https://shop.line.me/@plarachefpraitoon",
        },
      ],
      promotions: [
        {
          id: "1",
          image: "/images/products/fermented-fish-chef-praidturey-savory/gallery1.jpg",
          url: "#",
        },
        {
          id: "2",
          image: "/images/products/fermented-fish-chef-praidturey-savory/gallery2.jpg",
          url: "#",
        },
        {
          id: "3",
          image: "/images/products/fermented-fish-chef-praidturey-savory/gallery3.jpg",
          url: "#",
        },
      ],
    },
    {
      id: "2",
      name: "ปลาร้าเชฟไพรฑูรย์ สูตรดั้งเดิม Plus+ (น้ำปลาร้าปรุงสุก)",
      size: "ปริมาณสุทธิ 400 มล.",
      price: {
        amount: '-',
        currency: "",
      },
      image: "/images/products/fermented-fish-chef-praidturey-original-plus-plus/image.jpg",
      category: ProductCategory.FISH_SAUCE,
      description: `ปลาร้าพรีเมียมจากขอนแก่น หอม กลมกล่อม เข้มข้นทุกหยด
                - ต้มสุกทุกขั้นตอน สะอาด ปลอดภัย ได้มาตรฐาน อย. ฮาลาล และ OTOP
                - ควบคุมรสชาติทุกขวด ด้วย QC และอุปกรณ์ชั่งตวงสูตรเฉพาะ
                - กลิ่นหอมไม่ติดมือ คนทำงานออฟฟิศก็ทานได้สบาย
                - อัดแน่นด้วยเนื้อปลาทุกหยด  มีไอโอดีนจากปลากระตัก วิตามินบี และโปรตีนสูง
                - ปรุงอาหารแล้วไม่เซ็งไม่บูดง่าย ด้วยกระบวนการเคี่ยวจนได้ที่
                - ใช้ได้สารพัดเมนู  ตำ ยำ หมักเนื้อ ไข่เจียว ลาบ ก้อย และอีกมากมาย
                - เป็นของดีเมืองขอนแก่น ของฝากจากเขื่อนอุบลรัตน์
                - ออกแบบรสชาติด้วยเชฟที่เชี่ยวชาญด้านเครื่องปรุงโดยตรง การันตีความคุ้มค่าทุกหยด แน่นอน`,
      shoppingPlatforms: [
        {
          id: "1",
          name: "น้ำปลาร้าเชฟไพรฑูรย์",
          platform: ShoppingPlatform.SHOPEE,
          logo: "/images/platforms/shopee.png",
          url: "https://shopee.co.th/chefpraitoon_official",
        },
        {
          id: "2",
          name: "Praitoon Food",
          platform: ShoppingPlatform.LAZADA,
          logo: "/images/platforms/lazada.png",
          url: "https://www.lazada.co.th/shop/praitoon-food",
        },
        {
          id: "3",
          name: "Praitoon Food",
          platform: ShoppingPlatform.TIKTOK,
          logo: "/images/platforms/tiktok.png",
          url: "https://vt.tiktok.com/ZSkpDWGYR",
        },
        {
          id: "4",
          name: "Praitoon Food",
          platform: ShoppingPlatform.LINE,
          logo: "/images/platforms/line-shopping.png",
          url: "https://shop.line.me/@plarachefpraitoon",
        },
      ],
      promotions: [
        {
          id: "1",
          image: "/images/products/fermented-fish-chef-praidturey-original-plus-plus/gallery1.webp",
          url: "#",
        },
        {
          id: "2",
          image: "/images/products/fermented-fish-chef-praidturey-original-plus-plus/gallery2.webp",
          url: "#",
        },
        {
          id: "3",
          image: "/images/products/fermented-fish-chef-praidturey-original-plus-plus/gallery3.webp",
          url: "#",
        },
        {
          id: "4",
          image: "/images/products/fermented-fish-chef-praidturey-original-plus-plus/gallery4.webp",
          url: "#",
        },
      ],
    },
    {
      id: "3",
      name: "ปลาร้าเชฟไพรฑูรย์ สูตรดั้งเดิม Original (น้ำปลาร้าปรุงสุก)",
      size: "ปริมาณสุทธิ 400 มล.",
      price: {
        amount: '-',
        currency: "",
      },
      image: "/images/products/fermented-fish-chef-praidturey-original/image.webp",
      category: ProductCategory.FISH_SAUCE,
      description: `ปลาร้าพรีเมียมจากขอนแก่น หอม กลมกล่อม เข้มข้นทุกหยด
                - ต้มสุกทุกขั้นตอน สะอาด ปลอดภัย ได้มาตรฐาน อย. ฮาลาล และ OTOP
                - ควบคุมรสชาติทุกขวด ด้วย QC และอุปกรณ์ชั่งตวงสูตรเฉพาะ
                - กลิ่นหอมไม่ติดมือ คนทำงานออฟฟิศก็ทานได้สบาย
                - อัดแน่นด้วยเนื้อปลาทุกหยด  มีไอโอดีนจากปลากระตัก วิตามินบี และโปรตีนสูง
                - ปรุงอาหารแล้วไม่เซ็งไม่บูดง่าย ด้วยกระบวนการเคี่ยวจนได้ที่
                - ใช้ได้สารพัดเมนู  ตำ ยำ หมักเนื้อ ไข่เจียว ลาบ ก้อย และอีกมากมาย
                - เป็นของดีเมืองขอนแก่น ของฝากจากเขื่อนอุบลรัตน์
                - ออกแบบรสชาติด้วยเชฟที่เชี่ยวชาญด้านเครื่องปรุงโดยตรง การันตีความคุ้มค่าทุกหยด แน่นอน`,
      shoppingPlatforms: [
        {
          id: "1",
          name: "น้ำปลาร้าเชฟไพรฑูรย์",
          platform: ShoppingPlatform.SHOPEE,
          logo: "/images/platforms/shopee.png",
          url: "https://shopee.co.th/chefpraitoon_official",
        },
        {
          id: "2",
          name: "Praitoon Food",
          platform: ShoppingPlatform.LAZADA,
          logo: "/images/platforms/lazada.png",
          url: "https://www.lazada.co.th/shop/praitoon-food",
        },
        {
          id: "3",
          name: "Praitoon Food",
          platform: ShoppingPlatform.TIKTOK,
          logo: "/images/platforms/tiktok.png",
          url: "https://vt.tiktok.com/ZSkpDWGYR",
        },
        {
          id: "4",
          name: "Praitoon Food",
          platform: ShoppingPlatform.LINE,
          logo: "/images/platforms/line-shopping.png",
          url: "https://shop.line.me/@plarachefpraitoon",
        },
      ],
      promotions: [
        {
          id: "1",
          image: "/images/products/fermented-fish-chef-praidturey-original/gallery1.webp",
          url: "#",
        },
        {
          id: "2",
          image: "/images/products/fermented-fish-chef-praidturey-original/gallery2.webp",
          url: "#",
        },
        {
          id: "3",
          image: "/images/products/fermented-fish-chef-praidturey-original/gallery3.webp",
          url: "#",
        },
      ],
    },
    {
      id: "5",
      name: "ปลาร้าเชฟไพรฑูรย์ สูตรดั้งเดิม PLUS+ (น้ำปลาร้าปรุงสุก)",
      size: "ปริมาณสุทธิ 5,800 มล.",
      price: {
        amount: '-',
        currency: "",
      },
      image: "/images/products/fermented-fish-sauce-chef-praidturey-plus/image.jpg",
      category: ProductCategory.FISH_SAUCE,
      description: `ปลาร้าพรีเมียมจากขอนแก่น หอม กลมกล่อม เข้มข้นทุกหยด
                - ต้มสุกทุกขั้นตอน สะอาด ปลอดภัย ได้มาตรฐาน อย. ฮาลาล และ OTOP
                - ควบคุมรสชาติทุกขวด ด้วย QC และอุปกรณ์ชั่งตวงสูตรเฉพาะ
                - กลิ่นหอมไม่ติดมือ คนทำงานออฟฟิศก็ทานได้สบาย
                - อัดแน่นด้วยเนื้อปลาทุกหยด  มีไอโอดีนจากปลากระตัก วิตามินบี และโปรตีนสูง
                - ปรุงอาหารแล้วไม่เซ็งไม่บูดง่าย ด้วยกระบวนการเคี่ยวจนได้ที่
                - ใช้ได้สารพัดเมนู  ตำ ยำ หมักเนื้อ ไข่เจียว ลาบ ก้อย และอีกมากมาย
                - เป็นของดีเมืองขอนแก่น ของฝากจากเขื่อนอุบลรัตน์
                - ออกแบบรสชาติด้วยเชฟที่เชี่ยวชาญด้านเครื่องปรุงโดยตรง การันตีความคุ้มค่าทุกหยด แน่นอน`,
      shoppingPlatforms: [
        {
          id: "1",
          name: "น้ำปลาร้าเชฟไพรฑูรย์",
          platform: ShoppingPlatform.SHOPEE,
          logo: "/images/platforms/shopee.png",
          url: "https://shopee.co.th/chefpraitoon_official",
        },
        {
          id: "2",
          name: "Praitoon Food",
          platform: ShoppingPlatform.LAZADA,
          logo: "/images/platforms/lazada.png",
          url: "https://www.lazada.co.th/shop/praitoon-food",
        },
        {
          id: "3",
          name: "Praitoon Food",
          platform: ShoppingPlatform.TIKTOK,
          logo: "/images/platforms/tiktok.png",
          url: "https://vt.tiktok.com/ZSkpDWGYR",
        },
        {
          id: "4",
          name: "Praitoon Food",
          platform: ShoppingPlatform.LINE,
          logo: "/images/platforms/line-shopping.png",
          url: "https://shop.line.me/@plarachefpraitoon",
        },
      ],
      promotions: [],
    },
    {
      id: "6",
      name: "ปลาร้าเชฟไพรฑูรย์ สูตรดั้งเดิม Original (น้ำปลาร้าปรุงสุก)",
      size: "ปริมาณสุทธิ 5,800 มล.",
      price: {
        amount: '-',
        currency: "",
      },
      image: "/images/products/fermented-fish-sauce-chef-praidturey-original/image.jpg",
      category: ProductCategory.FISH_SAUCE,
      description: `ปลาร้าพรีเมียมจากขอนแก่น หอม กลมกล่อม เข้มข้นทุกหยด
                - ต้มสุกทุกขั้นตอน สะอาด ปลอดภัย ได้มาตรฐาน อย. ฮาลาล และ OTOP
                - ควบคุมรสชาติทุกขวด ด้วย QC และอุปกรณ์ชั่งตวงสูตรเฉพาะ
                - กลิ่นหอมไม่ติดมือ คนทำงานออฟฟิศก็ทานได้สบาย
                - อัดแน่นด้วยเนื้อปลาทุกหยด  มีไอโอดีนจากปลากระตัก วิตามินบี และโปรตีนสูง
                - ปรุงอาหารแล้วไม่เซ็งไม่บูดง่าย ด้วยกระบวนการเคี่ยวจนได้ที่
                - ใช้ได้สารพัดเมนู  ตำ ยำ หมักเนื้อ ไข่เจียว ลาบ ก้อย และอีกมากมาย
                - เป็นของดีเมืองขอนแก่น ของฝากจากเขื่อนอุบลรัตน์
                - ออกแบบรสชาติด้วยเชฟที่เชี่ยวชาญด้านเครื่องปรุงโดยตรง การันตีความคุ้มค่าทุกหยด แน่นอน`,
      shoppingPlatforms: [
        {
          id: "1",
          name: "น้ำปลาร้าเชฟไพรฑูรย์",
          platform: ShoppingPlatform.SHOPEE,
          logo: "/images/platforms/shopee.png",
          url: "https://shopee.co.th/chefpraitoon_official",
        },
        {
          id: "2",
          name: "Praitoon Food",
          platform: ShoppingPlatform.LAZADA,
          logo: "/images/platforms/lazada.png",
          url: "https://www.lazada.co.th/shop/praitoon-food",
        },
        {
          id: "3",
          name: "Praitoon Food",
          platform: ShoppingPlatform.TIKTOK,
          logo: "/images/platforms/tiktok.png",
          url: "https://vt.tiktok.com/ZSkpDWGYR",
        },
        {
          id: "4",
          name: "Praitoon Food",
          platform: ShoppingPlatform.LINE,
          logo: "/images/platforms/line-shopping.png",
          url: "https://shop.line.me/@plarachefpraitoon",
        },
      ],
      promotions: [],
    },
    {
      id: "7",
      name: "น้ำจิ้มเนื้อวัว ตรา เชฟไพรฑูรย์",
      size: "ปริมาณสุทธิ 630 มล.",
      price: {
        amount: '-',
        currency: "",
      },
      image: "/images/products/beef-dipping-sauce-chef-praidturey/630ml.webp",
      category: ProductCategory.BEEF_DIP,
      description: `ดีวัวแท้นำเข้าจากประเทศออสเตเรีย มีเอกสารรับรองการนำเข้า
                    ได้รับมาตรฐาน Thai FDA
                    ดีวัวเข้มข้น เหมาะสำหรับปรุงเมนูอาหารอีสาน เช่น ลาบ ก้อย น้ำจิ้มแจ่ว อุเพี้ย เป็นต้น
                    ผลิตจากวัตถุดิบคุณภาพดี กลิ่นหอม ขมนัว ไม่เค็ม`,
      shoppingPlatforms: [
        {
          id: "1",
          name: "น้ำปลาร้าเชฟไพรฑูรย์",
          platform: ShoppingPlatform.SHOPEE,
          logo: "/images/platforms/shopee.png",
          url: "https://shopee.co.th/chefpraitoon_official",
        },
        {
          id: "2",
          name: "Praitoon Food",
          platform: ShoppingPlatform.LAZADA,
          logo: "/images/platforms/lazada.png",
          url: "https://www.lazada.co.th/shop/praitoon-food",
        },
        {
          id: "3",
          name: "Praitoon Food",
          platform: ShoppingPlatform.TIKTOK,
          logo: "/images/platforms/tiktok.png",
          url: "https://vt.tiktok.com/ZSkpDWGYR",
        },
        {
          id: "4",
          name: "Praitoon Food",
          platform: ShoppingPlatform.LINE,
          logo: "/images/platforms/line-shopping.png",
          url: "https://shop.line.me/@plarachefpraitoon",
        },
      ],
      promotions: [],
    },
    {
      id: "9",
      name: "น้ำจิ้มเนื้อวัว ตรา เชฟไพรฑูรย์",
      size: "ปริมาณสุทธิ 100 มล.",
      price: {
        amount: '-',
        currency: "",
      },
      image: "/images/products/beef-dipping-sauce-chef-praidturey/100ml.webp",
      category: ProductCategory.BEEF_DIP,
      description: `ดีวัวแท้นำเข้าจากประเทศออสเตเรีย มีเอกสารรับรองการนำเข้า
                    ได้รับมาตรฐาน Thai FDA
                    ดีวัวเข้มข้น เหมาะสำหรับปรุงเมนูอาหารอีสาน เช่น ลาบ ก้อย น้ำจิ้มแจ่ว อุเพี้ย เป็นต้น
                    ผลิตจากวัตถุดิบคุณภาพดี กลิ่นหอม ขมนัว ไม่เค็ม`,
      shoppingPlatforms: [
        {
          id: "1",
          name: "น้ำปลาร้าเชฟไพรฑูรย์",
          platform: ShoppingPlatform.SHOPEE,
          logo: "/images/platforms/shopee.png",
          url: "https://shopee.co.th/chefpraitoon_official",
        },
        {
          id: "2",
          name: "Praitoon Food",
          platform: ShoppingPlatform.LAZADA,
          logo: "/images/platforms/lazada.png",
          url: "https://www.lazada.co.th/shop/praitoon-food",
        },
        {
          id: "3",
          name: "Praitoon Food",
          platform: ShoppingPlatform.TIKTOK,
          logo: "/images/platforms/tiktok.png",
          url: "https://vt.tiktok.com/ZSkpDWGYR",
        },
        {
          id: "4",
          name: "Praitoon Food",
          platform: ShoppingPlatform.LINE,
          logo: "/images/platforms/line-shopping.png",
          url: "https://shop.line.me/@plarachefpraitoon",
        },
      ],
      promotions: [],
    },
    {
      id: "10",
      name: "แก้วเก็บความเย็น ปลาร้าเชฟไพรฑูรย์",
      size: "ขนาด 30 oz.",
      price: {
        amount: '-',
        currency: "",
      },
      image: "/images/products/cold-cup-fermented-fish-chef-praidturey/image.jpg",
      category: ProductCategory.OTHER,
      description: ``,
      shoppingPlatforms: [
        {
          id: "1",
          name: "น้ำปลาร้าเชฟไพรฑูรย์",
          platform: ShoppingPlatform.SHOPEE,
          logo: "/images/platforms/shopee.png",
          url: "https://shopee.co.th/chefpraitoon_official",
        },
        {
          id: "2",
          name: "Praitoon Food",
          platform: ShoppingPlatform.LAZADA,
          logo: "/images/platforms/lazada.png",
          url: "https://www.lazada.co.th/shop/praitoon-food",
        },
        {
          id: "3",
          name: "Praitoon Food",
          platform: ShoppingPlatform.TIKTOK,
          logo: "/images/platforms/tiktok.png",
          url: "https://vt.tiktok.com/ZSkpDWGYR",
        },
        {
          id: "4",
          name: "Praitoon Food",
          platform: ShoppingPlatform.LINE,
          logo: "/images/platforms/line-shopping.png",
          url: "https://shop.line.me/@plarachefpraitoon",
        },
      ],
      promotions: [],
    },
    {
      id: "11",
      name: "ร่มกัน UV ปลาร้าเซฟไพรฑูรย์",
      size: "สีแดง",
      price: {
        amount: '-',
        currency: "",
      },
      image: "/images/products/uv-umbrella-chef-praidturey/image.jpg",
      category: ProductCategory.OTHER,
      description: ``,
      shoppingPlatforms: [
        {
          id: "1",
          name: "น้ำปลาร้าเชฟไพรฑูรย์",
          platform: ShoppingPlatform.SHOPEE,
          logo: "/images/platforms/shopee.png",
          url: "https://shopee.co.th/chefpraitoon_official",
        },
        {
          id: "2",
          name: "Praitoon Food",
          platform: ShoppingPlatform.LAZADA,
          logo: "/images/platforms/lazada.png",
          url: "https://www.lazada.co.th/shop/praitoon-food",
        },
        {
          id: "3",
          name: "Praitoon Food",
          platform: ShoppingPlatform.TIKTOK,
          logo: "/images/platforms/tiktok.png",
          url: "https://vt.tiktok.com/ZSkpDWGYR",
        },
        {
          id: "4",
          name: "Praitoon Food",
          platform: ShoppingPlatform.LINE,
          logo: "/images/platforms/line-shopping.png",
          url: "https://shop.line.me/@plarachefpraitoon",
        },
      ],
      promotions: [],
    },
    {
      id: "12",
      name: "ผ้ากันเปื้อน ปลาร้าเชฟไพรฑูรย์",
      size: "สีดำ,สีแดง",
      price: {
        amount: '-',
        currency: "",
      },
      image: "/images/products/apron-fermented-fish-chef-praidturey/image.jpg",
      category: ProductCategory.OTHER,
      description: ``,
      shoppingPlatforms: [
        {
          id: "1",
          name: "น้ำปลาร้าเชฟไพรฑูรย์",
          platform: ShoppingPlatform.SHOPEE,
          logo: "/images/platforms/shopee.png",
          url: "https://shopee.co.th/chefpraitoon_official",
        },
        {
          id: "2",
          name: "Praitoon Food",
          platform: ShoppingPlatform.LAZADA,
          logo: "/images/platforms/lazada.png",
          url: "https://www.lazada.co.th/shop/praitoon-food",
        },
        {
          id: "3",
          name: "Praitoon Food",
          platform: ShoppingPlatform.TIKTOK,
          logo: "/images/platforms/tiktok.png",
          url: "https://vt.tiktok.com/ZSkpDWGYR",
        },
        {
          id: "4",
          name: "Praitoon Food",
          platform: ShoppingPlatform.LINE,
          logo: "/images/platforms/line-shopping.png",
          url: "https://shop.line.me/@plarachefpraitoon",
        },
      ],
      promotions: [],
    },
    {
      id: "13",
      name: "เสื้อยืดปลาร้าเชฟไพรฑูรย์ ผ้า Cotton 100%",
      size: "สีแดง,สีดำ,สีขาว",
      price: {
        amount: '-',
        currency: "",
      },
      image: "/images/products/tshirt-fermented-fish-chef-praidturey-cotton100/image.jpg",
      category: ProductCategory.OTHER,
      description: ``,
      shoppingPlatforms: [
        {
          id: "1",
          name: "น้ำปลาร้าเชฟไพรฑูรย์",
          platform: ShoppingPlatform.SHOPEE,
          logo: "/images/platforms/shopee.png",
          url: "https://shopee.co.th/chefpraitoon_official",
        },
        {
          id: "2",
          name: "Praitoon Food",
          platform: ShoppingPlatform.LAZADA,
          logo: "/images/platforms/lazada.png",
          url: "https://www.lazada.co.th/shop/praitoon-food",
        },
        {
          id: "3",
          name: "Praitoon Food",
          platform: ShoppingPlatform.TIKTOK,
          logo: "/images/platforms/tiktok.png",
          url: "https://vt.tiktok.com/ZSkpDWGYR",
        },
        {
          id: "4",
          name: "Praitoon Food",
          platform: ShoppingPlatform.LINE,
          logo: "/images/platforms/line-shopping.png",
          url: "https://shop.line.me/@plarachefpraitoon",
        },
      ],
      promotions: [],
    },
  ],
  shoppingPlatforms: [
    {
      id: "1",
      name: "น้ำปลาร้าเชฟไพรฑูรย์",
      platform: ShoppingPlatform.SHOPEE,
      logo: "/images/platforms/shopee.png",
      url: "https://shopee.co.th/chefpraitoon_official",
    },
    {
      id: "2",
      name: "Praitoon Food",
      platform: ShoppingPlatform.LAZADA,
      logo: "/images/platforms/lazada.png",
      url: "https://www.lazada.co.th/shop/praitoon-food",
    },
    {
      id: "3",
      name: "Praitoon Food",
      platform: ShoppingPlatform.TIKTOK,
      logo: "/images/platforms/tiktok.png",
      url: "https://vt.tiktok.com/ZSkpDWGYR",
    },
    {
      id: "4",
      name: "Praitoon Food",
      platform: ShoppingPlatform.LINE,
      logo: "/images/platforms/line-shopping.png",
      url: "https://shop.line.me/@plarachefpraitoon",
    },
    {
      id: "5",
      name: "Praitoon Food",
      platform: ShoppingPlatform.FACEBOOK,
      logo: "/images/platforms/facebook.png",
      url: "https://www.facebook.com/Chefpraitoonoffice",
    },
  ],
};
